import HomePage from "@/pages/home-page";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { LazyLoadingSpinner } from "@/components/LazyLoadingSpinner";

export const Route = createFileRoute("/home")({
  component: HomePage,
  beforeLoad: async ({ context: { isAuthenticated } }) => {
    if (!isAuthenticated) {
      throw redirect({ to: "/login" });
    }
    return { isAuthenticated };
  },
  pendingComponent: () => <LazyLoadingSpinner />
});
